module.exports = __webpack_public_path__ + "img/app_android_d.2a85220e.png";